import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TransactionsRevisionReasonsListComponent } from './transactions-revision-reasons-list/transactions-revision-reasons-list.component';
import { TransactionsRevisionReasonsDetailComponent } from './transactions-revision-reasons-detail/transactions-revision-reasons-detail.component';

const routes: Routes = [
    {
        path: 'transactionsRevisionReasons',
        children: [
            { path: '', component: TransactionsRevisionReasonsListComponent }
        ]
    },
    {
        path: 'transactionsRevisionReasons/:id',
        children: [
            { path: '', component: TransactionsRevisionReasonsDetailComponent }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class TransactionsRevisionReasonsRoutingModule { }
